import './style.sass';

import { Row, Col, Container, Button, Form } from 'react-bootstrap';

import Youtube from '../../assets/img/icons/youtubeVedio.svg';
import QuizOption from '../../components/QuizOption';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';
import { SPFoptions } from '../../components';
import ReactTooltip from 'react-tooltip';
import { BeatLoader } from 'react-spinners';
import DashedSegments from '../../components/DashedSegments';

export default function Step3({ updateCount }) {
  const dispatch = useDispatch();
  const [occupancyChecked, setOccupancyChecked] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [message, setMessage] = useState('');
  const [previousAnswer, setPreviousAnswer] = useState(null);
  const [review, setReview] = useState({});
  const changeOccupancyChecked = (val) => {
    setOccupancyChecked(val);
  };

  const [question, setQuestion] = useState({});
  const [isPassageLoading, setIsPassageLoading] = useState(false);

  const [
    questionId,
    userQuizAnswer,
    questionState,
    reviewStepsSubmitted,
    reviewResponse,
    userQuizId,
    feedbackStatus,
  ] = useSelector((state) => {
    return [
      state.review.questionId,
      state.review.userQuizAnswer,
      state.review.singleQuestion,
      state.review.reviewStepsSubmitted,
      state.review.reviewResponse,
      state.review.userQuizId,
      state.review.feedbackStatus,
    ];
  });
  const [mathInputValue, setMathInputValue] = useState('');

  const isValidSPRInput = (input) => {
    if (input === '' || input === '-') return true;

    const pattern = /^-?(\d*(\.\d*)?|\d+\/\d*)$/;

    if (!pattern.test(input)) {
      return false;
    }

    const digits = input.replace(/[^0-9]/g, '');
    return digits.length <= 6;
  };

  const handleMathInputChange = (event) => {
    event.stopPropagation();
    const { value } = event.target;
    if (isValidSPRInput(value)) {
      setMathInputValue(value);
    }
  };

  useEffect(() => {
    setOccupancyChecked(mathInputValue || null);
  }, [mathInputValue]);

  useEffect(() => {
    if (questionId && userQuizAnswer) {
      dispatch(Actions.dispatchGetQuestion(questionId));
      setPreviousAnswer(userQuizAnswer);
    }
  }, [questionId, userQuizAnswer, dispatch]);

  useEffect(() => {
    if (questionState) {
      setIsPassageLoading(true);
      setTimeout(() => {
        var doc = [];
        doc = document.getElementsByClassName('line-ref');
        var inputList = Array.prototype.slice.call(doc);
        inputList?.map((item) => {
          try {
            var result = item.innerText.substring(6, item.innerText.length - 1);
            const getLine = document.getElementById(`${result}_start`).nextSibling;
            item.innerHTML = `<a data-tip="${getLine.textContent}" onclick="onLineRefClicked('${result}_start_highlight')" href="#${result}_start">line</a>`;
            document.getElementById(
              `${result}_start`,
            ).innerHTML = `<span id="${result}_start_highlight">${getLine.textContent}</span>`;
            document.getElementById(`${result}_start`).nextSibling.remove();
          } catch (err) {
            console.log('Error in line ref', err);
          }
        });
        setIsPassageLoading(false);
        ReactTooltip.rebuild();
      }, 800);
      setQuestion(questionState);
    }
  }, [questionState, userQuizAnswer]);

  useEffect(() => {
    if (reviewStepsSubmitted.length >= 3) {
      console.log('Answer is ', reviewStepsSubmitted[2]?.answer);
      setOccupancyChecked(reviewStepsSubmitted[2]?.answer);
      setIsSubmitted(true);
    }
  }, [reviewStepsSubmitted]);

  useEffect(() => {
    if (reviewResponse) {
      if (reviewResponse?.review) {
        setReview(JSON.parse(reviewResponse?.review));
      }
    }
  }, [reviewResponse]);

  return (
    <>
      <Container className="step-3">
        {question?.section?.title === 'Reading' && isPassageLoading && (
          <>
            <div className="text-center">
              <BeatLoader color={'#10A0DE'} size={30} loading={isPassageLoading} />
            </div>
          </>
        )}
        <Row
          style={{ marginRight: '0' }}
          className={question?.section?.title !== 'Reading' ? '' : isPassageLoading ? 'd-none' : ''}
        >
          <Col md={6}>
            <div className={'passageBox'}>
              <div>
                {typeof question?.passage?.direction != undefined &&
                typeof question?.passage?.attribution != undefined &&
                typeof question?.passage?.body != undefined ? (
                  <>
                    {question?.passage?.direction ? (
                      <>
                        <div
                          className={'title'}
                          dangerouslySetInnerHTML={{
                            __html: question?.passage?.direction,
                          }}
                        />
                      </>
                    ) : null}

                    {question?.passage?.attribution ? (
                      <>
                        <div
                          className={'description'}
                          dangerouslySetInnerHTML={{
                            __html: question?.passage?.attribution,
                          }}
                        />
                      </>
                    ) : null}
                    {question?.passage?.body ? (
                      <>
                        <div
                          className={'description'}
                          dangerouslySetInnerHTML={{
                            __html: question?.passage?.body,
                          }}
                        />
                      </>
                    ) : null}
                  </>
                ) : (
                  <>
                    <div className="stepBox">
                      <div style={{ display: 'flex' }}>
                        <h1>{question?.orderId}.</h1>
                        <div>
                          <h1
                            className="stepBoxText"
                            dangerouslySetInnerHTML={{
                              __html: question?.title,
                            }}
                          ></h1>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Col>
          <Col style={{ background: ' #FFFFFF', paddingTop: '30px', marginBottom: '50px' }} md={6}>
            <Row
              style={{
                alignItems: 'center',
                display: 'flex',
                padding: '10px 20px',
              }}
            >
              <div style={{ fontWeight: 700 }}>Your previous answer:</div>
              <Row style={{ flex: 1 }}>
                {question?.answer?.answerType === 'SINGLE_CORRECT' && (
                  <>
                    <Col md={3} sm={3} xs={3}>
                      <QuizOption
                        name={'question_option'}
                        label={' A '}
                        value={''}
                        changeChecked={() => {}}
                        saveQuizAnswer={() => {}}
                        backgroundColor={previousAnswer === 'A' ? true : false}
                      />
                    </Col>
                    <Col md={3} sm={3} xs={3}>
                      <QuizOption
                        name={'question_option'}
                        label={' B '}
                        value={''}
                        changeChecked={() => {}}
                        saveQuizAnswer={() => {}}
                        backgroundColor={previousAnswer === 'B' ? true : false}
                      />
                    </Col>
                    <Col md={3} sm={3} xs={3}>
                      <QuizOption
                        name={'question_option'}
                        label={' C '}
                        value={''}
                        changeChecked={() => {}}
                        saveQuizAnswer={() => {}}
                        backgroundColor={previousAnswer === 'C' ? true : false}
                      />
                    </Col>
                    <Col md={3} sm={3} xs={3}>
                      <QuizOption
                        name={'question_option'}
                        label={' D '}
                        value={''}
                        changeChecked={() => {}}
                        saveQuizAnswer={() => {}}
                        backgroundColor={previousAnswer === 'D' ? true : false}
                      />
                    </Col>
                  </>
                )}
                {question?.answer?.answerType === 'SPR' && (
                  <h5 style={{ textAlign: 'right' }}>
                    Submitted answer: <span className="text-bg-danger">{userQuizAnswer}</span>
                  </h5>
                )}
              </Row>
              {previousAnswer?.toLowerCase === 'skip' && (
                <Button
                  style={{
                    width: '100px',
                    color: '#4EA2E2',
                    background: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    marginTop: '10px',
                  }}
                >
                  Skipped
                </Button>
              )}
            </Row>
            <DashedSegments />
            <div style={{ padding: '10px 20px 0', fontWeight: 700 }}>Try again:</div>
            <div className="stepBox">
              <div style={{ display: 'flex' }}>
                <h1>{question?.orderId}.</h1>
                <div>
                  <h1
                    className="stepBoxText"
                    dangerouslySetInnerHTML={{
                      __html: question?.title,
                    }}
                  ></h1>
                  {question?.answer?.answerType === 'SINGLE_CORRECT' && (
                    <>
                      <div class="quiz_option_wrapper">
                        <QuizOption
                          name={'question_option'}
                          label={'A'}
                          value={question?.answer?.choices[0]}
                          changeChecked={changeOccupancyChecked}
                          checked={occupancyChecked}
                          saveQuizAnswer={() => {}}
                          disabled={isSubmitted ? true : false}
                        />
                      </div>
                      <div class="quiz_option_wrapper">
                        <QuizOption
                          name={'question_option'}
                          label={'B'}
                          value={question?.answer?.choices[1]}
                          changeChecked={changeOccupancyChecked}
                          checked={occupancyChecked}
                          saveQuizAnswer={() => {}}
                          disabled={isSubmitted ? true : false}
                        />
                      </div>
                      <div class="quiz_option_wrapper">
                        <QuizOption
                          name={'question_option'}
                          label={'C'}
                          value={question?.answer?.choices[2]}
                          changeChecked={changeOccupancyChecked}
                          checked={occupancyChecked}
                          saveQuizAnswer={() => {}}
                          disabled={isSubmitted ? true : false}
                        />
                      </div>
                      <div class="quiz_option_wrapper">
                        <QuizOption
                          name={'question_option'}
                          label={'D'}
                          value={question?.answer?.choices[3]}
                          changeChecked={changeOccupancyChecked}
                          checked={occupancyChecked}
                          saveQuizAnswer={() => {}}
                          disabled={isSubmitted ? true : false}
                        />
                      </div>
                    </>
                  )}

                  {question?.answer?.answerType === 'SPR' && (
                    <>
                      <div>
                        <Form
                          onSubmit={(event) => {
                            event.preventDefault();
                          }}
                        >
                          <Form.Group className="mb-3" controlId="formBasicMathEmail">
                            <Form.Label>Your Answer</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter your answer"
                              onChange={handleMathInputChange}
                              maxLength={6}
                              value={mathInputValue}
                            />
                            <Form.Text className="text-muted">
                              Accept numbers, [ - ], [ . ] or [ / ]
                              <div>Maximum input of 6 characters</div>
                              <div>
                                The input must be a valid number, and the leading zero before the
                                decimal point can be omitted.
                              </div>
                              <div>E.g., -.0088 and .0088 are both valid.</div>
                            </Form.Text>
                          </Form.Group>
                        </Form>
                      </div>
                      <div className="math_answer_wrapper">
                        <div>Answer preview:</div>
                        <span className="math_answer">
                          {(() => {
                            let displayValue = mathInputValue;
                            if (displayValue.startsWith('.')) {
                              displayValue = '0' + displayValue;
                            } else if (displayValue.startsWith('-.')) {
                              displayValue = '-0' + displayValue.slice(1);
                            }
                            if (displayValue.includes('/')) {
                              const parts = displayValue.split('/');
                              let sign = '';
                              let numerator = parts[0].trim();
                              let denominator = parts[1].trim();
                              if (numerator.startsWith('-')) {
                                sign = '-';
                                numerator = numerator.slice(1);
                              }
                              return (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  {sign && (
                                    <div
                                      style={{
                                        marginRight: '5px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: '100%',
                                      }}
                                    >
                                      {sign}
                                    </div>
                                  )}
                                  <div
                                    className="fraction"
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <div className="math_item">{numerator}</div>
                                    <hr style={{ width: '100%', margin: '0' }} />
                                    <div className="math_item">{denominator}</div>
                                  </div>
                                </div>
                              );
                            } else {
                              return <div className="math_item">{displayValue}</div>;
                            }
                          })()}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {!isSubmitted && (
              <Col md={12} offset={1} style={{ padding: '0 20px' }}>
                <Button
                  onClick={() => {
                    if (occupancyChecked) {
                      var tempAns = occupancyChecked;
                      const temp = review;
                      if (temp.length >= 2) {
                        if (temp.length === 2) {
                          temp.push({
                            time: 20,
                            answer: tempAns,
                          });
                        } else if (temp.length > 2) {
                          temp[2] = {
                            time: 20,
                            answer: tempAns,
                          };
                        }

                        dispatch(
                          Actions.dispatchUpdateReview({
                            userQuizId: userQuizId,
                            questionId: questionState?.id,
                            reviewFeedback: 'PENDING',
                            review: JSON.stringify(temp),
                          }),
                        );

                        dispatch(Actions.saveReviewStep(temp));
                        if (tempAns === question?.answer?.isCorrect.toUpperCase()) {
                          setMessage('Correct');
                        } else {
                          setMessage('Incorrect');
                        }
                        setIsSubmitted(true);
                        dispatch(Actions.saveSelectedAnswer(tempAns));
                      }
                    }
                  }}
                  style={{
                    background: '#4EA2E2',
                    border: 'none',
                    padding: '10px 50px',
                  }}
                  disabled={!occupancyChecked}
                >
                  Submit
                </Button>
              </Col>
            )}
            {isSubmitted && (
              <Col md={12} offset={1} style={{ marginLeft: '20px' }}>
                <h4>{message}</h4>
                <Button
                  onClick={() => {
                    updateCount();
                  }}
                  style={{
                    background: '#4EA2E2',
                    border: 'none',
                    padding: '10px 50px',
                  }}
                >
                  Go to Step 4: Check Solution
                </Button>
              </Col>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}
